// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TechnicalAreaView_Wrapper__2_fAT","Image":"TechnicalAreaView_Image__33Krd","Text":"TechnicalAreaView_Text__1uabu"};